import { Box, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FunctionComponent } from 'react';
import { MdErrorOutline as ErrorOutlineIcon } from 'react-icons/md';
import oxTheOx from '../../../assets/images/ox-the-ox.svg';

const useStyles = makeStyles()((theme: Theme) => ({
  content: {
    flexGrow: 1,
    marginTop: theme.spacing(10),
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  icon: {
    marginBottom: theme.spacing(2),
    fill: theme.palette.primary.main,
  },
}));

const InviteOnlyPage: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.content}>
      <Box
        component='img'
        src={oxTheOx}
        alt='page not found'
        maxHeight='80vh'
        mb={2}
      />
      <ErrorOutlineIcon width='48px' height='48px' className={classes.icon} />
      <Typography variant='h5' color='textPrimary'>
        You do not have permissions to use the App
      </Typography>
      <Typography variant='h6'>
        OX Security App is for invited members only
      </Typography>
      <Typography variant='body2'>
        Please contact your system administrator
      </Typography>
    </Box>
  );
};

export default InviteOnlyPage;
